import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "c-title f-nm t-center",
  style: {"margin-top":"50px"}
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode("There are currently no positions")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ThePositionItem = _resolveComponent("ThePositionItem")
  const _component_RealTimeQuote = _resolveComponent("RealTimeQuote")
  const _component_TheTradeGroup = _resolveComponent("TheTradeGroup")
  const _component_List = _resolveComponent("List")
  const _component_t = _resolveComponent("t")
  const _component_Nullable = _resolveComponent("Nullable")
  const _component_Holder = _resolveComponent("Holder")

  return (_openBlock(), _createBlock(_component_Holder, {
    content: _ctx.positions,
    sync: "",
    "holder-class": "px-16"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_Nullable, { content: _ctx.positions }, {
        emptyMsg: _withCtx(() => [
          _createVNode(_component_t, { path: "symbol_25" }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          (_ctx.positions[0].productId === _ctx.positions[0].code)
            ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                (_ctx.showAll)
                  ? (_openBlock(), _createBlock(_component_TheTradeGroup, {
                      key: 0,
                      list: _ctx.positions
                    }, {
                      default: _withCtx(({item}) => [
                        _createVNode(_component_RealTimeQuote, { symbol: item }, {
                          default: _withCtx(({price, buy}) => [
                            _createVNode(_component_ThePositionItem, {
                              order: item,
                              class: "position",
                              key: item.orderId,
                              profit: _ctx.profit(item, price, buy)
                            }, null, 8, ["order", "profit"])
                          ]),
                          _: 2
                        }, 1032, ["symbol"])
                      ]),
                      _: 1
                    }, 8, ["list"]))
                  : (_openBlock(), _createBlock(_component_List, {
                      key: 1,
                      "list-data": _ctx.positions
                    }, {
                      default: _withCtx(({item}) => [
                        _createVNode(_component_RealTimeQuote, { symbol: item }, {
                          default: _withCtx(({price, buy}) => [
                            _createVNode(_component_ThePositionItem, {
                              order: item,
                              class: "px-16",
                              key: item.orderId,
                              profit: _ctx.profit(item, price, buy)
                            }, null, 8, ["order", "profit"])
                          ]),
                          _: 2
                        }, 1032, ["symbol"])
                      ]),
                      _: 1
                    }, 8, ["list-data"]))
              ], 64))
            : (_openBlock(), _createBlock("div", _hoisted_1, "Your account does not support trading, please download the APP to log in to view trading"))
        ]),
        _: 1
      }, 8, ["content"])
    ]),
    _: 1
  }, 8, ["content"]))
}